import { APP_LOADING, APP_MESSAGE, SET_CONTRAST, FONT_SIZE } from "../constants";

const INITIAL_STATE = {
  loading: false,
  message: "",
  appContrast: false,
  appFontSize: 0,
};

const updateFontSize = (currentFontSize) =>
  currentFontSize === 2 ? 0 : currentFontSize + 1;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APP_LOADING:
      return { ...state, loading: action.payload };
    case APP_MESSAGE:
      return { ...state, message: action.payload, loading: false };
    case SET_CONTRAST:
      return { ...state, appContrast: !state.appContrast };
    case FONT_SIZE:
      return { ...state, appFontSize: updateFontSize(state.appFontSize) };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js